import Common from './Common';
import '../../css/main.scss';

$(document).ready(() => {
    // eslint-disable-next-line no-new
    new Common();
});
